<script>
import Modal from "@/components/modals/modal-form.vue";
import CustomTable from "@/components/tables/custom-table.vue";
import vue2Dropzone from "vue2-dropzone";
import OrderShow from "@/views/pages/orders/show/show.vue";

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        product: Object
    },
    data() {
        return {
            activeTab: 0,
            table: {
                fields: [
                    { key: "id", label: "Cod", sortable: true },
                    { key: "name", label: "Nombre", sortable: true },
                    { key: "order_item", label: "Pedido", sortable: false },
                    { key: "created_at", label: "Fecha de creación", sortable: true },
                ],
                formatted_fields: [
                    'created_at',
                    'order_item'
                ]
            },
            dropzoneOptions: {
                method: 'post',
                thumbnailWidth: 150,
                maxFilesize: 10, //MB
                acceptedFiles: 'image/*,application/pdf',
                paramName: 'file',
                withCredentials: true,
                addRemoveLinks: false,
                // Ensure uploads happen sequentially in queue order
                parallelUploads: 1,
                uploadMultiple: false,
                autoProcessQueue: true,
            },
            showOrderModalId: 'showOrderModalId',
            showSelectedOrderId: null
        }
    },
    components: {
        Modal,
        CustomTable,
        OrderShow,
        vueDropzone: vue2Dropzone
    },
    computed: {
        modalTitle() {
            return `Archivos del producto - ${(this?.product?.name || '')}`;
        },
        tableUrl() {
            return `/products/${this.product?.id}/files`;
        },
        dropzoneUrl() {
            return process.env.VUE_APP_API_URL + `products/${this.product?.id}/files`;
        }
    },
    methods: {
        shown() {
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        handleComplete() {
            let dropzoneInstance = this.$refs['myVueDropzone'].dropzone;
            let fileWithError = 0;
            for (let i = dropzoneInstance.files.length - 1; i >= 0; i--) {
                let file = dropzoneInstance.files[i];
                if (file.status !== 'success') {
                    fileWithError++;
                    break;
                }
            }

            if(fileWithError == 0){
                this.activeTab = 0;
                dropzoneInstance.removeAllFiles();
                this.$refs.productFilesTable.refresh();
            }
        },
        handleError(file, message) {
            try {
                const errorResponse = message;
                if (errorResponse?.extra?.[0]?.errors?.file) {
                    const errorMessages = errorResponse.extra[0].errors.file;
                    file.previewElement.querySelector('.dz-error-message').textContent = errorMessages.join(', ');
                } else if (errorResponse?.errors?.[0]?.detail) {
                    file.previewElement.querySelector('.dz-error-message').textContent = errorResponse.errors[0].detail;
                }
            } catch (e) {
                console.log(e);
                file.previewElement.querySelector('.dz-error-message').textContent = 'Error al subir el archivo';
            }
        },
        formatter() {
        },
        downloadFile(item) {
            window.open(process.env.VUE_APP_API_URL + `products/${this.product?.id}/files/${item?.id}/download`, '_blank');
        },
        showViewModal(order) {
            this.showSelectedOrderId = order?.id;
            this.$bvModal.show(this.showOrderModalId);
        }
    }
};
</script>

<template>
    <Modal :title="modalTitle" :id="modalId" @cancel="cancel" @shown="shown" :size="'extra-xl'" :showConfirmButton="false" :label-cancel-btn="'Cerrar'">
        <OrderShow :modal-id="showOrderModalId" :id="showSelectedOrderId"></OrderShow>
        <div class="card h-100">
            <div class="card-body">
                <b-tabs content-class="p-3 text-muted" v-model="activeTab">
                    <b-tab lazy>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="ri-file-list-line"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Archivos existentes</span>
                        </template>
                        <CustomTable
                            ref="productFilesTable"
                            :url="tableUrl"
                            :fields="table.fields"
                            :formatted-fields="table.formatted_fields"
                            :formatter="formatter"
                            :show-view="false"
                            :show-edit="false"
                            :showSoftDelete="false"
                            :showHardDelete="true"
                        >
                            <template #cell-created_at="{ item }">
                                <span v-format-date="item?.created_at"></span>
                            </template>
                            <template #cell-order_item="{ item }">
                                <a href="javascript:void(0)" v-if="item?.order_item?.order" @click="showViewModal(item?.order_item?.order)">{{ item?.order_item?.order?.id }} ({{
                            item?.order_item?.order?.external_id }})</a>
                                <span v-else>N/A</span>
                            </template>
                            <template v-slot:before-custom-actions="slotProps">
                                <a href="javascript:void(0);" 
                                    class="text-primary" 
                                    v-b-tooltip.hover 
                                    title="Descargar archivo"
                                    @click="downloadFile(slotProps.row?.item)">
                                    <i class="ri-download-line font-size-18"></i>
                                </a>
                            </template>
                        </CustomTable>
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                                <i class="ri-upload-cloud-line"></i>
                            </span>
                            <span class="d-none d-sm-inline-block">Subir archivos</span>
                        </template>
                        <div>
                            <vue-dropzone
                                v-if="product?.id"
                                id="dropzone"
                                ref="myVueDropzone"
                                :use-custom-slot="true"
                                :options="{...dropzoneOptions, url: dropzoneUrl}"
                                @vdropzone-queue-complete="handleComplete"
                                @vdropzone-error="handleError"
                            >
                                <div class="dropzone-custom-content">
                                    <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                                    <h4>Arrastre y suelte los archivos aquí o haga clic para subirlos</h4>
                                </div>
                            </vue-dropzone>
                            <div v-else class="text-center text-muted">
                                <i class="display-4 bx bx-error-circle"></i>
                                <h4>No se puede subir archivos sin un producto seleccionado</h4>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </Modal>
</template> 